import { BrowserCacheLocation, Configuration, LogLevel } from '@azure/msal-browser';
import { environment } from '../environments/environment';

export const msalConfig: Configuration = {
  auth: {
    clientId: environment.msalConfig.clientId,
    authority: environment.msalConfig.authority,
    redirectUri: environment.msalConfig.redirectUri,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
  system: {
    allowPlatformBroker: false,
    loggerOptions: {
      loggerCallback,
      logLevel: LogLevel.Warning,
      piiLoggingEnabled: false,
    },
  },
};

export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}
